<template>
  <div class="bounding-box-container">
    <div ref="boudingBox" class="bouding-box">
      <div ref="switch" class="switch">
        <div ref="tracker" class="switch-tracker" :style="`width: ${buttonWidth}px; transform: translateX(${trackerPosition}px);`"></div>

        <button v-for="(tab, index) in tabs" :key="index"
          class="switch-button" 
          :style="`min-width: ${buttonWidth}px; max-width: ${buttonWidth}px;`"
          :class="selectedBerging === tab.id ? 'switch-button-active' : ''" 
          @click="$emit('change', tab.id)"
        >
          <img class="switch-button-image" :src="`${previewsServer}/textures/ui/new/${tab.name.toLowerCase()}.png`">
          <span class="switch-button-label">
            {{ tab.name }} 
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: "tab-selector",

    props: {
      tabs: Array,
      selectedBerging: String,
    },

    data () {
      return {
        //position: 0,
        previewsServer: import.meta.env.VITE_VUE_APP_PREVIEWS_SERVER,
        buttonWidth: 0,
      }
    },

    computed: {
       ...mapGetters({
        currentPath: 'getCurrentPath',
      }),
      trackerPosition() {
        // console.log('hier', this.selectedBerging, this.tabs)
        return this.realTrackerPosition() * (this.buttonWidth + 8);
      },
    },

    methods: {
      realTrackerPosition() {
        // console.log(this.tabs)
        return this.tabs.findIndex(tab => tab.id === this.selectedBerging);
      },
    },

    mounted () {
      // console.log('hier', this.$refs.switch.clientWidth)
      this.buttonWidth = (this.$refs.switch.clientWidth - 3*8) / 4
    },

    /*watch: {
      currentPath(to) {
        for(let i=0; i<this.tabs.length; i++) {
          if(to.substring(to.lastIndexOf('/'), to.length) === this.tabs[i].route) {
            this.position = i
          }
          console.log(this.tabs)
          console.log(to)
        }
      }
    }*/

    // watch: {
    //   $router () {
    //     this.handleResize()
    //   }
    // }
  }
</script>

<style lang="scss" scoped>
.bounding-box-container {
  background: $c-background-1;
  border-radius: $radius-m;
  padding: 2px;
}

.bouding-box {
  display: flex;
  background: white;
  border-radius: $radius-m - $radius-s/2;
  overflow: hidden;
  padding: 8px;
  width: 100%;
  box-sizing: border-box;
}

.switch {
  display: flex;
  gap: 8px;
  position: relative;
  z-index: 10;
  transition: transform 200ms ease;
  width: 100%;

  &-button {
    background: transparent;
    border: none;
    display: flex;
    color: $c-secondary-text;
    z-index: 12;
    transition: color 200ms ease;
    text-decoration: none;
    transition: background-color 100ms ease;
    flex-direction: column;
    gap: 8px;
    flex:1;

    &-image {
      width: 100%;
      border: 1px dashed $c-primary;
      box-sizing: border-box;
    }

    &-label {
      height: 56px;
      font-weight: 600;
      font-family: 'Oswald', sans-serif;
      text-transform: uppercase;
      color: $c-primary;
      font-size: 19px;
      width: 75%;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;

      @media (max-width: 999px) {
        font-size: 14px;
      }
    }

    &:hover {
      background-color: $c-background-1-hover;
      cursor: pointer;
    }

    &-active {
      & span {
        color: $c-secondary; //$c-secondary;
      }

      &:hover {
        background-color: transparent;
        cursor: default;
      }
    }
  }

  &-tracker {
    content: "";
    position: absolute;
    background-color: $c-primary;
    height: 56px;
    bottom: 0;
    z-index: 11;
    border-radius: $radius-m;
    transition: transform 200ms ease, width 100ms ease;
  }
}


</style>